<template>
  <div class="fill-height">
    <div ref="jwPlayerContainer">{{ loadErrorText }}</div>
  </div>
</template>

<script>
import { mapGetters } from "pinia"

import { useUserSessionStore } from "@/store/userSession.js"

import jwPlayerImagePath from "@/assets/jwplayer-play.svg"

const playerRefreshTimeInSeconds = 6 * 3600

export default {
  props: {
    video: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      player: null,
      refreshIntervalHandler: null,
      jwPlayerImagePathUrl: `url(${jwPlayerImagePath})`,
      loadErrorText: null
    }
  },
  computed: {
    ...mapGetters(useUserSessionStore, ["sessionQueryString"]),
    localUrl() {
      //Playlist_url is full URL like https://kaskade.disciplemedia.com:8080/api/v1/videos/512
      //Need to extract /api relative path here
      if (!this.video.playlist_url) {
        return null
      }
      const url = new URL(this.video.playlist_url)
      return url.pathname
    },
    setupOptions() {
      //Request headers can be set only when using playlist option
      //But then it does not work on safari browser
      //See https://developer.jwplayer.com/jw-player/docs/developer-guide/customization/configuration-reference/
      //"MANIFEST AND SEGMENT REQUESTS WITH CUSTOM HEADERS"
      return {
        file: `${this.localUrl}?${this.sessionQueryString}`,
        type: "m3u8",
        image: this.video.thumbnail_url,
        preload: "none"
      }
    }
  },
  mounted() {
    this.initPlayer()
    //Refresh player, it seems that it is crashing when e.g browser is opened overnight
    this.refreshIntervalHandler = setInterval(() => {
      this.removePlayer()
      this.initPlayer()
    }, playerRefreshTimeInSeconds * 1000)
  },
  beforeUnmount() {
    this.removePlayer()
    clearInterval(this.refreshIntervalHandler)
  },
  methods: {
    initPlayer() {
      try {
        if (typeof jwplayer === "undefined") {
          throw Error("jwplayer not found")
        }

        this.player = window.jwplayer(this.$refs.jwPlayerContainer)
        this.player.setup(this.setupOptions)
      } catch (err) {
        this.$reportError(err)
        this.loadErrorText = "Video"
      }
    },
    removePlayer() {
      if (this.player) {
        this.player.remove()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.jw-svg-icon-play) {
  background-image: v-bind(jwPlayerImagePathUrl);
  background-size: contain;
  background-repeat: no-repeat;

  path {
    display: none;
  }
}
</style>
